import React, {useCallback, useEffect, useState} from 'react';
import {Input, List} from 'antd'
import DraggableModal from "../../components/DraggableModal";
import TeacherItem from "./item";
import Api from '../../api'
const {Search} = Input;

export default function TeacherModal({onClose, isShow}) {
    const [list, setList] = useState([])
    const [pageIndex, setPageIndex] = useState(1)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [searchOptions, setSearchOptions] = useState({})

    useEffect(()=>{
        loadData();
    },[pageIndex])

    const [isOpen, setIsOpen] = useState(false)
    useEffect(() => {
        setIsOpen(isShow)
    }, [isShow])


    const loadData = useCallback((reset=false, params)=>{
        if (loading) return;
        setLoading(true)
        Api.getLecturerList({
            ...searchOptions,
            ...params,
            pageIndex: reset ? 1: pageIndex,
            pageSize: 9
        }).then(resp=>{
            setLoading(false)
            setList(resp.list||[])
            setPageIndex(resp.pageIndex)
            setTotal(resp.totalCount)
        })
    })

    const doSearch = useCallback((value) => {
        setSearchOptions({lecturerName: value})
        loadData(true,{lecturerName: value})
    })

    const save = useCallback(() => {
        onClose()
    })

    const onSelect = useCallback((data) => {
        onClose(data)
    })

    return <DraggableModal
        title="讲师列表"
        open={isOpen}
        onOk={save}
        onCancel={()=>onClose()}
        okText="确认"
        cancelText="取消"
        footer={null}
        width={760}
    >
        <Search
            className="pdh16"
            placeholder="搜索讲师名称"
            allowClear
            enterButton="搜索"
            size="large"
            onSearch={doSearch}
        />

        <List
            className="mgt28 mgb32"
            size="small"
            grid={{column: 3}}
            pagination={{
                total: total,
                pageSize: 9,
                showSizeChanger:false,
                onChange: (index)=>setPageIndex(index)
            }}
            dataSource={list}
            renderItem={(item) => <List.Item>
                <TeacherItem data={item} onSelect={onSelect}/>
            </List.Item>}
        />

    </DraggableModal>
}